"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTwingle;
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../app/contexts");
var _contexts2 = require("../box/contexts");
var _backButton = _interopRequireDefault(require("./back-button"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function useTwingle(alternativeAction, isFeedbackShown) {
  const {
    twingleWidgetUrl
  } = (0, _react.useContext)(_contexts.Settings);
  const [widgetExpanded, setWidgetExpanded] = (0, _react.useState)(false);
  const startTwingle = twingleWidgetUrl ? e => {
    if (e) e.preventDefault();
    setWidgetExpanded(true);
  } : alternativeAction;
  const twingleWidget = twingleWidgetUrl && widgetExpanded && /*#__PURE__*/_react.default.createElement(TwingleWidget, {
    exit: () => setWidgetExpanded(false),
    widgetUrl: twingleWidgetUrl
  });
  (0, _react.useEffect)(() => setWidgetExpanded(false), [isFeedbackShown]);
  return [twingleWidget, startTwingle];
}
function TwingleWidget(_ref) {
  let {
    exit,
    widgetUrl
  } = _ref;
  const amount = (0, _react.useContext)(_contexts2.Amount);
  const widgetId = "_rl60hvpcu"; // random string

  useTwingleResizeListener();
  const url = `${widgetUrl}/${widgetId}?tw_amount=${amount.val}${amount.isMonthly ? "&tw_rhythm=monthly" : ""}`;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "donation-encourager__twingle-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_backButton.default, {
    onClick: exit
  }), /*#__PURE__*/_react.default.createElement("iframe", {
    scrolling: "no",
    id: `twingleframe-${widgetId}`,
    src: url,
    style: {
      width: "100%",
      border: "none",
      overflow: "hidden",
      height: "400px",
      position: "relative",
      zIndex: 2
    }
  }));
} // see: https://spenden.twingle.de/embed/dekoder-ggmbh/dekoder-org/tw5979cc899e735/widget

function useTwingleResizeListener() {
  (0, _react.useEffect)(() => {
    const __twingleMessageListener = function (event) {
      if (event.data && event.data.type && event.data.cid) {
        var __twingleWidgetIframe = document.getElementById("twingleframe-" + event.data.cid);
        if (__twingleWidgetIframe) {
          switch (event.data.type) {
            case "size":
              __twingleWidgetIframe.style.height = event.data.value + "px";
              break;
            case "geturl":
              __twingleWidgetIframe.contentWindow.postMessage({
                type: "seturl",
                value: window.location.href
              }, "*");
              break;
            case "scrollToTop":
              if (typeof __twingleWidgetIframe.scrollIntoView !== "undefined") {
                __twingleWidgetIframe.scrollIntoView(true);
                if (window.scrollTo) {
                  // in some cases we need some offset, the iframe will tell us
                  var offset = event.data.value ? event.data.value : 0; // scroll 80px more to avoid sticky headers

                  offset -= 80;
                  window.scrollTo(0, window.scrollY + offset);
                }
              }
              break;
          }
        }
      }
    };
    window.addEventListener("message", __twingleMessageListener, false);
    return () => window.removeEventListener("message", __twingleMessageListener);
  }, []);
}